export class RedirectService {
  static redirectTo(path: string): void {
    window.location.assign(path);
  }
}
